import { MutableRefObject } from 'react';

export const createScrollHandler = (
  isLoading: boolean,
  hasMore: boolean,
  loadFn: () => void,
  scrollTimeoutRef: MutableRefObject<NodeJS.Timeout | undefined>
) => {
  return (e: React.UIEvent<HTMLDivElement>) => {
    e.preventDefault();
    const target = e.currentTarget;
    clearTimeout(scrollTimeoutRef.current);

    scrollTimeoutRef.current = setTimeout(() => {
      const bottomReached =
        target.scrollTop + target.clientHeight >= target.scrollHeight - 100;

      if (bottomReached && !isLoading && hasMore) {
        loadFn();
      }
    }, 500);
  };
};
